import Lottie from "lottie-react";
import { ReactNode, useContext, useEffect, useState } from 'react';
import { DataContext } from 'providers/data';

import Modals from 'components/views/Modals';
import Tooltip from 'components/views/Tooltip';
import Collapse from '@mui/material/Collapse';
import CarouselCars from 'components/views/CarouselCars';
import FadeAnimation from 'components/views/FadeAnimation';
import { ButtonRectangle } from 'components/views/form/Button';
import { Box, Typography, AccordionSummary, AccordionDetails } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ReactComponent as IcChatOnline } from 'assets/icons/ic-chat-online.svg';
import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';

import loadingJson from 'assets/animation/loading_quotation.json';

import { AccordionCustom, Label, ContentLabel, BoxFlex, RadioButton, BoxColumn, ContentBtn, SelectFake, LinkExtermal } from './styles';

type ParamsAccordion = {
    title: string;
    children: ReactNode;
}

const Accordion = ({ title, children }: ParamsAccordion) => {
    return (
        <AccordionCustom>
            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                <Typography fontSize='1rem' fontWeight={700}>
                    {title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{
                width: '100%',
                display: 'flex',
                padding: {
                    xs: '1.5625rem 0 0',
                    md: '1.1875rem 3rem 1.1875rem 0'
                },
                justifyContent: 'center',
            }}>
                {children}
            </AccordionDetails>
        </AccordionCustom>
    );
}

const MyPerfil = () => {
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [existDetails, setExistDetails] = useState(false);
    const [selectedCarState, setSelectedCarState] = useState(0);
    const { dataPerfilUser, selectedCar, handleGetPerfilUser } = useContext(DataContext);

    const handleGetPerfilUserState = () => {
        if (selectedCar) {
            setIsLoading(true);
            handleGetPerfilUser({ token: localStorage.getItem('token')!, nrPlatform: selectedCar.NR_PLATAFORMA });
        }
    }

    useEffect(() => {
        setIsLoading(false);
        if (selectedCar?.NR_PLATAFORMA !== selectedCarState) {
            handleGetPerfilUserState();
            setSelectedCarState(selectedCar?.NR_PLATAFORMA!);
        }

        if (dataPerfilUser && (selectedCar?.NR_TIPO_PRODUTO === 12)) {
            setExistDetails(true);
        } else {
            setExistDetails(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataPerfilUser, selectedCar]);

    return (
        <FadeAnimation>
            <Box>
                <CarouselCars />
                <Box sx={{ borderTop: '1px solid #D9D9D9', paddingTop: { xs: '1.125rem', md: '1.5625rem' } }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                        marginBottom: { xs: '1.5625rem', md: '2.25rem' },
                        'button': {
                            width: '100%',
                            fontSize: { xs: '.9375rem', md: '1.125rem' },
                            maxWidth: { xs: '9.875rem', md: '13rem' },
                            height: { xs: '2.1875rem', md: '2.5rem' },
                        }
                    }}>
                        {existDetails &&
                            <>
                                <Typography sx={{ fontSize: { xs: '.85rem', md: '1.125rem' }, maxWidth: { xs: '10.25rem', md: '29.5rem' } }}>
                                    Perfil apresentado de acordo com o <strong>veículo selecionado:</strong>
                                </Typography>
                                <ButtonRectangle name='EDITAR PERFIL' onClick={() => setShowModal(true)} />
                            </>
                        }
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '1.5625rem', md: '2.1875rem' } }}>
                        <Collapse in={isLoading}>
                            <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', flexDirection: 'column', height: '115px' }}>
                                <Typography fontSize='1.25rem' fontWeight={700} color='primary.light'>
                                    Buscando perfil
                                </Typography>

                                <Box sx={{ marginTop: '5px', svg: { maxHeight: '90px' } }}>
                                    <Lottie animationData={loadingJson} loop={true} />
                                </Box>
                            </Box>
                        </Collapse>
                        {!isLoading && existDetails && dataPerfilUser &&
                            <>
                                <Accordion title='Dados pessoais'>
                                    <ContentLabel>
                                        <BoxFlex sx={{ width: { xs: '100%', md: '90%' } }}>
                                            <Box sx={{ width: '100%' }}>
                                                <Label>
                                                    <p className='title'>
                                                        Data de nascimento
                                                    </p>
                                                    <p className='description'>
                                                        {dataPerfilUser?.DT_NASCIMENTO}
                                                    </p>
                                                </Label>
                                                <Box sx={{ display: { xs: 'block', md: 'none', marginTop: '.93rem' } }}>
                                                    <Label>
                                                        <p className='title'>
                                                            Sexo
                                                        </p>
                                                        <p className='description'>
                                                            {dataPerfilUser?.SEXO}
                                                        </p>
                                                    </Label>
                                                </Box>
                                            </Box>
                                            <Label>
                                                <p className='title'>
                                                    Estado Civil
                                                </p>
                                                <p className='description'>
                                                    {dataPerfilUser?.ESTADO_CIVIL}
                                                </p>
                                            </Label>
                                            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                                                <Label>
                                                    <p className='title'>
                                                        Sexo
                                                    </p>
                                                    <p className='description'>
                                                        {dataPerfilUser?.SEXO}
                                                    </p>
                                                </Label>
                                            </Box>
                                        </BoxFlex>
                                    </ContentLabel>
                                </Accordion>
                                <Accordion title='Dados do veículo'>
                                    <BoxFlex sx={{ width: '100%', flexDirection: { xs: 'column', md: 'row' } }}>
                                        <BoxColumn sx={{ width: { xs: '100%', md: '53%' }, maxWidth: { xs: '75%', md: '100%' }, margin: '0 auto', alignItems: { xs: 'center', md: 'start' } }}>
                                            <BoxFlex sx={{ justifyContent: 'start !important', gap: '4.18rem' }}>
                                                <Box>
                                                    <Label>
                                                        <p className='title'>
                                                            CEP Pernoite
                                                        </p>
                                                        <p className='description'>
                                                            {dataPerfilUser?.CEP_PERNOITE.substring(0, 5)}-{dataPerfilUser?.CEP_PERNOITE.substring(5, 8)}
                                                        </p>
                                                    </Label>
                                                </Box>
                                                <Box>
                                                    <Label>
                                                        <p className='title'>
                                                            Utilização do veículo
                                                        </p>
                                                        <p className='description'>
                                                            {dataPerfilUser?.UTILIZACAO_VEICULO}
                                                        </p>
                                                    </Label>
                                                </Box>
                                            </BoxFlex>
                                            <Label>
                                                <p className='title'>
                                                    Existe um condutor do veículo entre 18 e 25 anos?
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.CONDUTOR_MENOR_26 === 'Sim' ? 'active' : 'disabled'} disabled>
                                                        Sim
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.CONDUTOR_MENOR_26 === 'Não' ? 'active' : 'disabled'} disabled>
                                                        Não
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>
                                            <Label>
                                                <p className='title'>
                                                    Veículo 0km?
                                                    <Tooltip>
                                                        <Typography fontSize='.625rem' color="inherit" fontWeight={600}>
                                                            Veículo retirado da concessionária no prazo de até 20 dias
                                                        </Typography>
                                                    </Tooltip>
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.ZERO_KM === 'Sim' ? 'active' : 'disabled'} disabled>
                                                        Sim
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.ZERO_KM === 'Não' ? 'active' : 'disabled'} disabled>
                                                        Não
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>
                                            <Label>
                                                <p className='title'>
                                                    Veículo possui Kit Gás?
                                                    <Tooltip>
                                                        <Typography fontSize='.625rem' color="inherit" fontWeight={600}>
                                                            O kit gás deve estar regularizado no documento do veículo
                                                        </Typography>
                                                    </Tooltip>
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.CONDUTOR_MENOR_26 === 'Sim' ? 'active' : 'disabled'} disabled>
                                                        Sim
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.CONDUTOR_MENOR_26 === 'Não' ? 'active' : 'disabled'} disabled>
                                                        Não
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>
                                            <Label>
                                                <p className='title'>
                                                    Veículo fica guardado em garagem fechada ou estacionamento?
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.GARAGEM_FECHADA === 'Sim' ? 'active' : 'disabled'} disabled>
                                                        Sim
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.GARAGEM_FECHADA === 'Não' ? 'active' : 'disabled'} disabled>
                                                        Não
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>
                                            <Label>
                                                <p className='title'>
                                                    Veículo blindado/rebaixado/tunado?
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.BLINDADO === 'Sim' ? 'active' : 'disabled'} disabled>
                                                        Sim
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.BLINDADO === 'Não' ? 'active' : 'disabled'} disabled>
                                                        Não
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>
                                        </BoxColumn>

                                        <BoxColumn sx={{ width: { xs: '100%', md: '47%' }, paddingLeft: { xs: '0', md: '4.9%' }, maxWidth: { xs: '75%', md: '100%' }, margin: { xs: '1.5625rem auto 0', md: '0 auto' }, alignItems: { xs: 'center', md: 'start' } }}>
                                            <Label>
                                                <p className='title'>
                                                    Veículo possui isenção de imposto?
                                                    <Tooltip>
                                                        <Typography fontSize='.625rem' color="inherit" fontWeight={600}>
                                                            Veículo adquirido com isenção de imposto (IPI/ICMS) independentemente da data da compra
                                                        </Typography>
                                                    </Tooltip>
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.ISENCAO_IMPOSTO === 'Sim' ? 'active' : 'disabled'} disabled>
                                                        Sim
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.ISENCAO_IMPOSTO === 'Não' ? 'active' : 'disabled'} disabled>
                                                        Não
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>
                                            {dataPerfilUser?.ISENCAO_IMPOSTO === 'Sim' &&
                                                <Label>
                                                    <p className='title'>
                                                        Por qual motivo teve isenção fiscal?
                                                    </p>
                                                    <SelectFake>
                                                        {dataPerfilUser?.MOTIVO_ISENCAO_FISCAL} <ExpandMoreIcon />
                                                    </SelectFake>
                                                </Label>
                                            }
                                            {dataPerfilUser?.ZERO_KM === 'Sim' &&
                                                <Label>
                                                    <p className='title'>
                                                        Data de saída da concessionária
                                                    </p>
                                                    <p className='description'>
                                                        {dataPerfilUser?.SAIDA_CONCESSIONARIA}
                                                    </p>
                                                </Label>
                                            }
                                            <Label>
                                                <p className='title'>
                                                    Utiliza veículo como meio de transporte ao trabalho?
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.TRANSPORTE_TRABALHO === 'Sim' ? 'active' : 'disabled'} disabled>
                                                        Sim
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.TRANSPORTE_TRABALHO === 'Não' ? 'active' : 'disabled'} disabled>
                                                        Não
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>
                                            <Label>
                                                <p className='title'>
                                                    Na residência?
                                                </p>
                                                <SelectFake>
                                                    {dataPerfilUser?.GARAGEM_RESIDENCIA}
                                                    <ExpandMoreIcon />
                                                </SelectFake>
                                            </Label>
                                            <Label>
                                                <p className='title'>
                                                    No trabalho?
                                                </p>
                                                <SelectFake>
                                                    {dataPerfilUser?.GARAGEM_TRABALHO}
                                                    <ExpandMoreIcon />
                                                </SelectFake>
                                            </Label>
                                            <Label>
                                                <p className='title'>
                                                    Na escola/faculdade?
                                                </p>
                                                <SelectFake>
                                                    {dataPerfilUser?.GARAGEM_FACULDADE}
                                                    <ExpandMoreIcon />
                                                </SelectFake>
                                            </Label>
                                        </BoxColumn>
                                    </BoxFlex>
                                </Accordion>
                                <Accordion title='Dados complementares'>
                                    <BoxFlex sx={{ width: '100%', flexDirection: { xs: 'column', md: 'row' } }}>
                                        <BoxColumn sx={{ width: { xs: '100%', md: '53%' }, maxWidth: { xs: '75%', md: '100%' }, margin: '0 auto', alignItems: { xs: 'center', md: 'start' } }}>
                                            <Label>
                                                <p className='title'>
                                                    Existe residente/dependente entre 18 e 26 anos?
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.CONDUTOR_MENOR_26 === 'Sim' ? 'active' : 'disabled'} disabled>
                                                        Sim
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.CONDUTOR_MENOR_26 === 'Não' ? 'active' : 'disabled'} disabled>
                                                        Não
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>
                                            <Label>
                                                <p className='title'>
                                                    Tempo de habilitação do principal condutor?
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.TEMPO_HABILITACAO !== 'Mais que 2 anos' ? 'active' : 'disabled'} disabled>
                                                        Até 2 anos
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.TEMPO_HABILITACAO === 'Mais que 2 anos' ? 'active' : 'disabled'} disabled>
                                                        Mais que 2 anos
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>
                                        </BoxColumn>

                                        <BoxColumn sx={{ width: { xs: '100%', md: '47%' }, paddingLeft: { xs: '0', md: '4.9%' }, maxWidth: { xs: '75%', md: '100%' }, margin: { xs: '1.5625rem auto 0', md: '0 auto' }, alignItems: { xs: 'center', md: 'start' } }}>
                                            {dataPerfilUser?.SEGURADO_PROPRIETARIO_LEGAL &&
                                                <Label>
                                                    <p className='title'>
                                                        Segurado é o proprietário legal do veículo?
                                                    </p>
                                                    <ContentBtn>
                                                        <RadioButton activebtn={dataPerfilUser?.SEGURADO_PROPRIETARIO_LEGAL === 'Sim' ? 'active' : 'disabled'} disabled>
                                                            Sim
                                                        </RadioButton>
                                                        <RadioButton activebtn={dataPerfilUser?.SEGURADO_PROPRIETARIO_LEGAL === 'Não' ? 'active' : 'disabled'} disabled>
                                                            Não
                                                        </RadioButton>
                                                    </ContentBtn>
                                                </Label>
                                            }
                                            <Label>
                                                <p className='title'>
                                                    Segurado é o principal condutor?
                                                    <Tooltip>
                                                        <Typography fontSize='.625rem' color="inherit" fontWeight={600}>
                                                            Principal condutor é quem utiliza o veículo mais do que 1 vez na semana.
                                                        </Typography>
                                                    </Tooltip>
                                                </p>
                                                <ContentBtn>
                                                    <RadioButton activebtn={dataPerfilUser?.SEGURADO_PRINCIPAL_CONDUTOR === 'Sim' ? 'active' : 'disabled'} disabled>
                                                        Sim
                                                    </RadioButton>
                                                    <RadioButton activebtn={dataPerfilUser?.SEGURADO_PRINCIPAL_CONDUTOR === 'Não' ? 'active' : 'disabled'} disabled>
                                                        Não
                                                    </RadioButton>
                                                </ContentBtn>
                                            </Label>

                                            {dataPerfilUser?.SEGURADO_PRINCIPAL_CONDUTOR === 'Não' &&
                                                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                                    <Typography fontSize='.75rem' fontWeight={700} color='primary.light'>
                                                        Dados do condutor
                                                    </Typography>

                                                    <Label>
                                                        <p className='title'>
                                                            Nome do condutor
                                                        </p>
                                                        <p className='description'>
                                                            {dataPerfilUser?.NOME_CONDUTOR}
                                                        </p>
                                                    </Label>

                                                    <BoxFlex>
                                                        <Box>
                                                            <Label>
                                                                <p className='title'>
                                                                    CPF do condutor
                                                                </p>
                                                                <p className='description'>
                                                                    {dataPerfilUser?.CPF_CONDUTOR}
                                                                </p>
                                                            </Label>
                                                        </Box>
                                                        <Box>
                                                            <Label>
                                                                <p className='title'>
                                                                    Data de nascimento
                                                                </p>
                                                                <p className='description'>
                                                                    {dataPerfilUser?.DATA_NASCIMENTO_CONDUTOR}
                                                                </p>
                                                            </Label>
                                                        </Box>
                                                    </BoxFlex>

                                                    <BoxFlex>
                                                        <Box>
                                                            <Label>
                                                                <p className='title'>
                                                                    Sexo do condutor
                                                                </p>
                                                                <p className='description'>
                                                                    {dataPerfilUser?.SEXO_CONDUTOR}
                                                                </p>
                                                            </Label>
                                                        </Box>
                                                        <Box>
                                                            <Label>
                                                                <p className='title'>
                                                                    Estado civil do condutor
                                                                </p>
                                                                <p className='description'>
                                                                    {dataPerfilUser?.ESTADO_CIVIL_CONDUTOR}
                                                                </p>
                                                            </Label>
                                                        </Box>
                                                    </BoxFlex>

                                                    <Label>
                                                        <p className='title'>
                                                            Vínculo com o segurado
                                                        </p>
                                                        <p className='description'>
                                                            {dataPerfilUser?.VINCULO_CONDUTOR_SEGURADO}
                                                        </p>
                                                    </Label>
                                                </Box>
                                            }
                                        </BoxColumn>
                                    </BoxFlex>
                                </Accordion>
                            </>
                        }

                        {!isLoading && !existDetails &&
                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', 'svg': { zIndex: '0' } }}>
                                <IcIturinCoverage />
                                <Box sx={{
                                    border: '1.5px solid rgba(10, 168, 227, 0.45)',
                                    borderRadius: '10px',
                                    maxWidth: '21.875rem',
                                    padding: '1.25rem 2.81rem 1.25rem',
                                    marginTop: '-30px',
                                    zIndex: '2',
                                    position: 'relative',
                                    backgroundColor: 'white',
                                    'button': {
                                        width: '100%',
                                        height: '2.5rem',
                                        marginTop: '.875rem'
                                    }
                                }}>
                                    <Typography fontSize='1.125rem' textAlign='center' fontWeight={700} lineHeight='30px'>
                                        Para o seu serviço Ituran, <br /> não há necessidade de perfil!
                                    </Typography>
                                </Box>
                            </Box>
                        }
                    </Box>
                </Box>

                <Modals open={showModal}>
                    <Box sx={{ textAlign: 'center', width: '90vw', maxWidth: '400px' }}>
                        <Box sx={{ borderRadius: '8px 8px 0 0', padding: { xs: '1.43rem .8rem .5625rem', md: '1.43rem 2rem .5625rem' } }}>
                            <Typography fontSize='1.5625rem' fontWeight={700}>
                                Deseja alterar seu perfil?
                            </Typography>
                            <Typography fontSize='.875rem' padding='.75rem 0 .3rem'>
                                Entre em nosso chat <strong>e faça já sua alteração!</strong>
                            </Typography>
                            <a href='https://api.whatsapp.com/send/?phone=551136169000' target='blank'>
                                <IcChatOnline />
                            </a>
                            <Typography fontSize='.875rem' fontWeight={600} lineHeight='1.3'>
                                Atendimento de Segunda à Sexta das 08h as 18h <br /> e aos Sábados das 8h às 14h
                            </Typography>
                        </Box>
                        <Box sx={{
                            borderRadius: '0 0 8px 8px',
                            padding: '.75rem 3.75rem 1.875rem',
                            backgroundColor: 'primary.main',
                            'button': {
                                width: '100%'
                            }
                        }}>
                            <Typography fontSize='.875rem' color='white' paddingBottom='.9375rem'>
                                Outros canais de atendimento:
                            </Typography>
                            <LinkExtermal href="tel:08007742000">
                                0800 774 2000
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                            <LinkExtermal href="tel:551136169000">
                                3616 - 9000
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                            <ButtonRectangle name='Fechar' onClick={() => setShowModal(false)} />
                        </Box>
                    </Box>
                </Modals>
            </Box>
        </FadeAnimation >
    );
}

export default MyPerfil;